import request from "@/lib/api/handler";
import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "../utils";
import { AdminPipelineCandidate } from "./candidate-pipeline";

export interface AdminSampleJobCandidateDetails extends AdminPipelineCandidate {
  summary: string;
  marketingSummary: string;
}

export const useAdminSampleJobCandidateQuery = (params: {
  jobTitle: string;
  jobDescription: string;
}) => {
  const { getAccessTokenSilently } = useAuth0();

  const {
    data: adminSampleJobCandidates,
    error: adminSampleJobCandidatesError,
    isLoading: adminSampleJobCandidatesLoading,
  } = useQuery({
    queryKey: QueryKeys.adminSampleJobMatches(params),
    enabled: !!(params.jobTitle && params.jobDescription),
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    async queryFn() {
      const token = await getAccessTokenSilently();
      return await request<AdminSampleJobCandidateDetails[]>({
        method: "POST",
        path: `/api/admin/job_opening/sample/generate_matches`,
        token,
        body: JSON.stringify(params),
      });
    },
  });

  return {
    adminSampleJobCandidates,
    adminSampleJobCandidatesError,
    adminSampleJobCandidatesLoading,
  };
};
